import React, { useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import Home from './Home';
import Login from './Login';
import Admin from './Admin';

function RouteLogger() {
  const location = useLocation();
  
  useEffect(() => {
    console.log('Route changed:', location.pathname);
  }, [location]);
  
  return null;
}

const Routes = () => (
  <>
    <RouteLogger />
    <Switch>
      <Route path="/movies" component={Home} />       {/* add: delegate /movies/* to Home router */}
      <Route path="/contact" component={Home} />
      <Route exact path="/" component={Home} />
      <Route path="/admin" component={Admin} />
      <Route path="/login" component={Login} />
      <Route component={Home} />                      {/* optional: fallback to Home */}
    </Switch>
  </>
);

export default Routes;
